import { api } from './client'

export const chat = (pid, message, conversationId, mode) => {
  const body = { message }
  if (conversationId) body.conversationId = conversationId
  if (mode) body.mode = mode
  return api.post(`/ai/programs/${pid}/chat`, body).then((r) => r.data)
}
export const listConversations = (pid) =>
  api.get(`/ai/programs/${pid}/conversations`).then((r) => r.data)
export const getMessages = (conversationId) =>
  api.get(`/ai/conversations/${conversationId}/messages`).then((r) => r.data)

export const rateMessage = (messageId, feedback) =>
  api.post(`/ai/messages/${messageId}/feedback`, { feedback }).then((r) => r.data)
